import { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { apiClient } from '@/lib/apiClient';
import './referral-landing.css';

export default function ReferralLanding() {
    const { code } = useParams();
    const navigate = useNavigate();
    const [referrerName, setReferrerName] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!code) {
            setError('کد معرف نامعتبر است');
            setLoading(false);
            return;
        }

        const fetchReferrer = async () => {
            try {
                const { data, error: apiError } = await apiClient.GET(
                    `/api/v1/referral/check/${code}`
                );
                if (apiError || !data) {
                    setError('کد معرف یافت نشد');
                } else {
                    setReferrerName(data.referrer_name);
                }
            } catch (e) {
                setError('خطا در دریافت اطلاعات');
            } finally {
                setLoading(false);
            }
        };

        fetchReferrer();
    }, [code]);

    const handleSignup = () => {
        navigate(`/signup?ref=${code}`);
    };

    if (loading) {
        return (
            <div className="referral-landing">
                <div className="landing-loading">در حال بارگذاری...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="referral-landing">
                <div className="landing-card landing-error">
                    <div className="landing-icon landing-icon-error">✕</div>
                    <h1>کد معرف نامعتبر است</h1>
                    <p>این کد معرف وجود ندارد یا منقضی شده است.</p>
                    <Link to="/" className="landing-btn landing-btn-secondary">
                        بازگشت به فروشگاه
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="referral-landing">
            <div className="landing-bg-shapes" aria-hidden="true">
                <div className="shape shape-1" />
                <div className="shape shape-2" />
                <div className="shape shape-3" />
            </div>

            <div className="landing-card">
                <div className="landing-icon">🎁</div>

                <h1 className="landing-title">شما دعوت شده‌اید!</h1>

                {referrerName && (
                    <p className="landing-subtitle">
                        <strong>{referrerName}</strong> شما را به ایران چارسوق دعوت کرده است.
                    </p>
                )}

                <div className="landing-code-box">
                    <span className="landing-code-label">کد معرفی</span>
                    <code className="landing-code">{code}</code>
                </div>

                <div className="landing-benefits">
                    <h3>با ثبت‌نام در ایران چارسوق:</h3>
                    <ul>
                        <li>
                            <span className="benefit-icon">✓</span>
                            <span>از تخفیف‌های ویژه خریداران جدید بهره‌مند می‌شوید</span>
                        </li>
                        <li>
                            <span className="benefit-icon">✓</span>
                            <span>می‌توانید لینک معرفی خودتان را بسازید و پورسانت بگیرید</span>
                        </li>
                        <li>
                            <span className="benefit-icon">✓</span>
                            <span>دسترسی به هزاران محصول از فروشندگان معتبر</span>
                        </li>
                    </ul>
                </div>

                <button
                    type="button"
                    className="landing-btn landing-btn-primary"
                    onClick={handleSignup}
                >
                    ثبت‌نام و دریافت تخفیف
                </button>

                <Link to="/" className="landing-btn landing-btn-secondary">
                    فقط نگاهی می‌اندازم
                </Link>
            </div>
        </div>
    );
}